import React, { useEffect } from 'react';
import StepsLayout, {
  TypeLayout
} from 'screens/Applications&WorkOrders/StepsLayout';
import {
  GO_BACK,
  useAgOperationUtility
} from 'screens/Applications&WorkOrders/StepsLayout/Context/AgOperationUtilityProvider';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import useConversionRecommendationToOperation from './Hooks/useConversionRecommendationToOperation';

export const CreateOperationFromRecommendation: React.FC = () => {
  const { updateUtilityState } = useAgOperationUtility();
  const {
    isLoading,
    convertRecommendationToOperationFormikData,
    targetOperation
  } = useConversionRecommendationToOperation();

  useEffect(() => {
    updateUtilityState({ returnPath: GO_BACK });
    convertRecommendationToOperationFormikData();
  }, [convertRecommendationToOperationFormikData, updateUtilityState]);

  const type =
    targetOperation === OperationType.WORK_ORDER
      ? TypeLayout.WORK_ORDER
      : TypeLayout.APPLICATION;

  return <StepsLayout isLoading={isLoading} type={type} />;
};

export default CreateOperationFromRecommendation;
